import { SolidifyableData } from "@lib/titan2/dist/api/core/data/SolidifyableData";
import { SlingoConstants } from "../enum/SlingoConstants";
/**
 * StakeToSpinData.ts
 */
export class StakeToSpinData extends SolidifyableData {
    constructor(data) {
        super(data);
        this.solidify();
    }
    solidify() {
        super.solidify();
        if (this.dataExists(this.data)) {
            this.stake = this.data.getNumber(SlingoConstants.PROPERTY_STAKE);
            this.win = this.data.getNumber(SlingoConstants.PROPERTY_WIN);
            this.currencyCode = this.data.getString(SlingoConstants.PROPERTY_CURRENCY);
            this.solidifyRNG(this.data.getDataObject(SlingoConstants.PROPERTY_FEATURE));
        }
    }
    solidifyRNG(data) {
        if (this.dataExists(data)) {
            this.rng = new StakeToSpinRNGData(data.getDataObject(SlingoConstants.PROPERTY_RNG));
        }
    }
    getStake() {
        return this.stake;
    }
    getWin() {
        return this.win;
    }
    getCurrencyCode() {
        return this.currencyCode;
    }
    getRng() {
        return this.rng;
    }
}
/**
 * StakeToSpinRNGData.ts
 */
export class StakeToSpinRNGData extends SolidifyableData {
    constructor(data) {
        super(data);
        this.solidify();
    }
    solidify() {
        super.solidify();
        if (this.dataExists(this.data)) {
            this.result = this.data.getNumber(SlingoConstants.PROPERTY_RESULT);
            this.bound = this.data.getNumber(SlingoConstants.PROPERTY_BOUND);
            this.weight = this.data.getNumber(SlingoConstants.PROPERTY_WEIGHT);
            this.isWinVal = this.data.getBool(SlingoConstants.PROPERTY_IS_WIN);
        }
    }
    getResult() {
        return this.result;
    }
    getBound() {
        return this.bound;
    }
    getWeight() {
        return this.weight;
    }
    isWin() {
        return this.isWinVal;
    }
}
//# sourceMappingURL=StakeToSpin.js.map